import { useEffect } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MiniFaqs, MINIFAQ_SOURCES } from '@/containers/MiniFaqs';
import { BrandsActive } from './active';
import { BrandsAll } from './all';
import { SuspendResidenceWarning } from '@/components/Warnings/SuspendResidenceWarning';
import { USER_STATUSES } from '@/helpers/constants';
import { BrandTabs } from '@/components/Tabs/BrandTabs';
import AnalyticsGA from '@/analyticsGA';
import { useGetMe } from '@/hooks/useGetMe';
import s from './index.module.scss';

const BrandsPage = () => {
  const { profile } = useGetMe();
  const { t } = useTranslation('brands');

  useEffect(() => {
    AnalyticsGA.pageNavigation('Brands');
  }, []);

  return (
    <div className={s.startups_page}>
      <div className="container-inner">
        <h1 className={classnames(s.startups_page__title, 'f-42 f-500')}>
          {t('startups.title')}
        </h1>
        <p className={classnames(s.startups_page__desc, 'f-16 f-400')}>
          {t('startups.description')}
        </p>
        <BrandTabs />
        {profile?.status === USER_STATUSES.suspended && (
          <SuspendResidenceWarning className={s.startups_page__warning} />
        )}
        <div className={s.startups_page__sections}>
          <BrandsActive />
          <BrandsAll />
        </div>
        <MiniFaqs source={MINIFAQ_SOURCES.founders} />
      </div>
    </div>
  );
};

export default BrandsPage;
